// Module
var code = `<div class="alert missing-tags-message" ng-if="\$ctrl.hasAnyNonSavedCustomFee()">
  Product has newly added custom fees, therefore not all tags can be shown. Please, save product to see all of them.
</div>

  <h2 class="section-header">GL account mappings</h2>

  <div class="filters">

      <div class="labelled-field">
        <label>Source product</label>
        <select ng-model="\$ctrl.sourceTypeId"
                ng-options="sourceType.id as sourceType.productName for sourceType in \$ctrl.sourceProductTypes">
          <option value=""></option>
        </select>
      </div>

      <!-- Action buttons -->
      <button ng-click="\$ctrl.copyMappings(\$ctrl.sourceTypeId)" class="btn btn-primary" ng-disabled="!\$ctrl.sourceTypeId">
        Copy mappings
      </button>
      <button ng-click="\$ctrl.resetMappings()" class="btn btn-danger">
        Reset mappings
      </button>

  </div>

  <table class="table gl-mappings__table">
    <thead>
    <tr>
      <th class="no-column-header">No</th>
      <th class="col-label">Name</th>
      <th class="col-delegate">Delegate</th>
      <th class="col-account">GL account</th>
      <th class="col-delegate-tag">GL tag</th>
    </tr>
    </thead>
    <tbody>

    <tr ng-repeat="tag in \$ctrl.visibleProductTags() track by tag.id">
      <td>{{\$index + 1}}.</td>
      <td>{{tag.label}}</td>
      <td class="centered-cell">
        <input
          type="checkbox"
          ng-model="tag.delegate"
          ng-change="\$ctrl.onDelegateChange(tag)">
      </td>
      <td>
        <div ng-if="tag.delegate">
          <selectize
            ng-disabled="tag.delegate"
            ng-model="\$ctrl.devnull"
            config="\$ctrl.emptyAccountConfig"
            options="[]">
          </selectize>
        </div>
        <div ng-if="!tag.delegate">
          <account-select
            ng-if="!tag.delegate"
            options="\$ctrl.ledgerAccounts"
            ng-model="tag"
            query-field="'accountCode'"
            label-field="'label'"
            value-field="'fullCode'"
            ng-required="!tag.delegate">
          </account-select>
        </div>
      </td>
      <td>
        <selectize
          ng-disabled="!tag.delegate"
          options="\$ctrl.ledgerTagTypes"
          config="\$ctrl.selectConfig"
          ng-required="tag.delegate"
          ng-model="tag.delegateTagType">
        </selectize>
      </td>
    </tr>
    </tbody>
  </table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/gl-mappings/gl-mappings.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;